<template>
    <div class="attempt-icon" :style="{background: colors[colors.theme].from}">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.61 62.61">
            <defs></defs>
            <g id="Camada_2" data-name="Camada 2">
                <g id="Layer_1" data-name="Layer 1">
                    <circle class="cls-1" :fill="colors[colors.theme].from" cx="31.3" cy="31.3" r="31.3"/>
                    <path  class="cls-2" :fill="colors.theme == 'dark' ? '#000' : '#fff'" d="M2.85,34.15a31.3,31.3,0,0,1,52-23.51A31.3,31.3,0,1,0,10.64,54.81,31.16,31.16,0,0,1,2.85,34.15Z"/>
                    <text :fill="colors.theme == 'dark' ? '#fff' : '#000'" class="cls-3" transform="translate(23.34 49.31)">1</text>
                </g>
            </g>
        </svg> -->
        <p :style="{color: colors.theme == 'dark' ? '#fff' : '#000'}">2</p>
    </div>
</template>

<script>

export default {
    name: 'Attempt1',
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
        // console.log('Colors: ', this.colors)
    }
}
</script>

<style lang="scss" scoped>
svg{
   font-weight: 700;
   height: 25px;
}
.attempt-icon{
    width: 25px !important;
    padding: 5px 1px;
    border-radius: 55px;
    margin: 0 4px;

    p{
        font-weight: bold;
        position: relative;     
    }
}
// .cls-1{fill:#fff;}.cls-2{fill:#ccc;}
.cls-3{font-size:42.7px;font-family:Raleway;}
</style>
